import { z } from 'zod';

export const CoreNotifySubscriberContactMethodScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','type','identifier','origin','invitedAt','invitedMethod','optedInAt','optedInMethod','optedOutAt','optedOutMethod','verifiedAt','verifiedMethod','status','phoneNumberSMSCapable','personId','rowTimestamp']);

export default CoreNotifySubscriberContactMethodScalarFieldEnumSchema;
